import {post} from './http'
const baseUrl = '/api'
export const getIndexCourse = v => post(`${baseUrl}/capwhale/course/index/getIndexCourse`, v.data, v.success, v.error)
export const getIndexCategory = v => post(`${baseUrl}/capwhale/course/index/getIndexCategory`, v.data, v.success, v.error)
export const getMIndexCourse = v => post(`${baseUrl}/capwhale/course/mob/index/getIndexCourse`, v.data, v.success, v.error)
export const getMCourseByKey = v => post(`${baseUrl}/capwhale/course/mob/search/getCourseByKey`, v.data, v.success, v.error)